import { mainMenu } from "../mocks/mainMenu";
import { IMainMenu } from "../types";

export function getSidebarMenu(path : string): [IMainMenu[], string] {
  const currentSelectedItem = mainMenu.find((item) => item.link === path);
  return [mainMenu, currentSelectedItem?.key || ""];
}
